import { useMemo, useState } from 'react';
import { ToothSurface } from '../../../../../graphql/graphql';
import { PATHOLOGY_ITEMS_SURFACES } from '../../../Components/DENTModalOverviewPathology/pathologyItemsSurfaces';
import { useDENTContext } from '../../../Services/DENTContext';
import useTooth from '../useTooth';
import { PathologyItem } from '../../../Enums/PathologyItem.enum';
import { SurfaceOperation } from '../../../Enums/SurfaceOperation.enum';

export default function useToothPathologyDecaySurfaces() {
	const [showedSurfaces, setShowedSurfaces] = useState<ToothSurface[]>(
		PATHOLOGY_ITEMS_SURFACES[PathologyItem.DECAY],
	);

	const { activeTooth } = useDENTContext();
	const {
		pathology: { decays },
	} = useTooth();

	const [decayIndex, setDecayIndex] = useState(
		activeTooth?.pathology?.decays?.length ?? 0,
	);

	const selectedSurfaces = useMemo(() => {
		return decays?.getSurfaces(decayIndex) ?? [];
	}, [activeTooth]);

	const handleSelectSurface = (
		surfaces: ToothSurface[],
		operation: SurfaceOperation,
	) => {
		decays?.setSurfaces(decayIndex, surfaces, operation);
	};

	return {
		showedSurfaces,
		setShowedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
		decayIndex,
		setDecayIndex,
	} as const;
}
